<template>
  <div class="cabinet-header">
    <div class="cabinet-title">
      {{ cabinetData.name }}
    </div>
    <DxButton v-if="cabinetData.cabinet_id && !insideCabinetSettings" class="cabinet-settings-button" icon="optionsgear" @click="goToCabinetSettings"/>
    <DxButton v-else-if="cabinetData.cabinet_id && insideCabinetSettings" class="cabinet-settings-button" icon="arrowback" @click="goToCabinetSearch"/>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { DxButton } from "devextreme-vue";
import { storeToRefs } from "pinia";
import { useHeaderStore } from "@/stores/headerStore.js";

const headerStore = useHeaderStore()
const { cabinetData } = storeToRefs(headerStore)

const route = useRoute()
const router = useRouter()
const insideCabinetSettings = computed(() => {
  return route.matched.some(r => r.name === 'cabinetSettings')
})
const goToCabinetSettings = () => { router.push({name: 'cabinetSettings'}) }
const goToCabinetSearch = () => { router.push({name: 'search'}) }
</script>

<style lang="scss">
  .cabinet-header{
    margin: 0 0 0 0.5rem;
    display: flex;
    align-items: center;

    .cabinet-title {
      font-size: 1.25rem !important;
      margin-right: 0.25rem;
    }

    .cabinet-settings-button {
      background-color: transparent !important;
      box-shadow: none !important;
    }
  }
</style>
